import React from 'react'

import { ModalBackground, ModalDialog } from './styles'
import enhance from './enhance'
import ModalHeader from './ModalHeader'
// exporting these here so we can do default import
// with named imports in the same statement
// import Modal, {ModalHeader, ModalBody, ...} from ...
export { default as ModalHeader } from './ModalHeader'
export { default as ModalBody } from './ModalBody'
export { default as ModalFooter } from './ModalFooter'
export { default as ModalTitle } from './ModalTitle'

const Component = ({
  bitComposition = false,
  children,
  className,
  handleBackgroundClose,
  isOpen,
  onClose,
  rightMargin,
  slim,
  title,
  wide,
  ...props
}) => (
  // handleBackgroundClick is defined in enhancer, used for handling onClose
  // data-testid given to modal is applied to ModalHeader, if present
  // data-testid="info_modalBackground" is important as is for background click
  <ModalBackground
    isOpen={isOpen}
    rightMargin={rightMargin}
    onClick={handleBackgroundClose}
    data-testid="info_modalBackground"
    bitComposition={bitComposition}
  >
    <ModalDialog isOpen={isOpen} className={className} slim={slim} wide={wide}>
      {title && (
        <ModalHeader
          title={title}
          onClose={onClose}
          data-testid={props['data-testid']}
        />
      )}
      {children}
    </ModalDialog>
  </ModalBackground>
)

Component.displayName = 'Modal'

export default enhance(Component)
